// ================= QZ TRAY VERSION =================

// import qz from "qz-tray";
// import Swal from 'sweetalert2';

// export const printMarkedOrder = async (orders, printerName) => {

//     try {
//         // 🔥 CHECK QZ CONNECTION
//         if (!qz.websocket.isActive()) {
//             await qz.websocket.connect();
//             console.log("✅ Connected to QZ Tray");
//         }

//     } catch (err) {
//         console.error(err);

//         Swal.fire({
//             icon: "error",
//             text: "Unable to connect to QZ Tray. Please make sure it is running."
//         });
//         return;
//     }

//     // 🖨️ CHECK PRINTER
//     if (!printerName) {
//         Swal.fire({
//             icon: 'warning',
//             title: 'Printer Required',
//             text: 'Please configure a Label Printer in Printer Settings.'
//         });
//         return;
//     }

//     const config = qz.configs.create(printerName);

//     const labels = [];

//     orders
//         .filter(
//             o =>
//                 o.Remarks === "Marked" ||
//                 o.Remarks === "In_Transit"
//         )
//         .forEach(order => {

//             const qty = Number(order.ItemQty) || 1;

//             for (let i = 0; i < qty; i++) {
//                 labels.push(createLabel(order));
//             }
//         });

//     const rawData = labels.join("\n");

//     try {

//         await qz.print(
//             config,
//             [{
//                 type: "raw",
//                 format: "command",
//                 data: rawData
//             }]
//         );

//     } catch (err) {
//         console.error(err);
//     }
// };

// const createLabel = (order) => {

//     const customerLines = wrapText(
//         order.CustomerName,
//         18
//     );

//     const itemLines = wrapText(
//         `${order.ItemName} - ${order.Cargo}`,
//         23
//     );

//     let y = 15;

//     let tspl = `
// SIZE 50 mm,30 mm
// GAP 2 mm,0 mm
// DIRECTION 1
// CLS
// `;

//     customerLines.forEach(line => {
//         tspl += `TEXT 20,${y},"3",0,1,1,"${line}"\n`;
//         y += 25;
//     });

//     tspl += `
//         BARCODE 20,${y + 5},"128",62,1,0,2,3,"${order.OrderID}"
// `;

//     y += 95;

//     itemLines.forEach(line => {
//         tspl += `TEXT 20,${y},"3",0,1,1,"${line}"\n`;
//         y += 35;
//     });

//     tspl += `
// PRINT 1
// `;

//     return tspl;
// };

// const wrapText = (text, maxChars = 20) => {
//     const words = text.split(" ");
//     const lines = [];
//     let line = "";

//     words.forEach(word => {
//         if ((line + word).length <= maxChars) {
//             line += (line ? " " : "") + word;
//         } else {
//             lines.push(line);
//             line = word;
//         }
//     });

//     if (line) lines.push(line);

//     return lines.slice(0, 2); // max 2 lines
// };





// ================= POPUP WINDOW VERSION =================

import Swal from "sweetalert2";
import JsBarcode from "jsbarcode";

export const printMarkedOrder = async (orders) => {

    const labels = [];

    orders
        .filter(
            order =>
                order.Remarks === "Marked" ||
                order.Remarks === "In_Transit"
        )
        .forEach(order => {

            const qty = Number(order.ItemQty) || 1;

            for (let i = 0; i < qty; i++) {
                labels.push(createLabelHtml(order));
            }
        });

    if (!labels.length) {
        Swal.fire({
            icon: "info",
            text: "No marked orders found."
        });
        return;
    }

    const printWindow = window.open("", "_blank");

    if (!printWindow) {
        Swal.fire({ icon: "error", text: "Unable to open print window. Please allow popups." });
        return;
    }


    printWindow.document.write(`
        <!DOCTYPE html>
        <html>
        <head>
            <title>Print Labels</title>

            <style>
                @page {
                    size: 50mm 30mm;
                    margin: 0;
                }

                html,
                body {
                    margin: 0;
                    padding: 0;
                    font-family: Arial, sans-serif;
                }

                .label {
                    width: 50mm;
                    height: 30mm;
                    box-sizing: border-box;
                    page-break-after: always;
                    overflow: hidden;
                    padding: 2mm;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                }

                .customer {
                    font-size: 11px;
                    font-weight: 700;
                    line-height: 1.2;
                }

                .barcode {
                    text-align: center;
                }

                .barcode svg {
                    width: 100%;
                    height: 40px;
                }

                .barcode-text {
                    font-size: 8px;
                    letter-spacing: 1px;
                }

                .item {
                    font-size: 10px;
                    line-height: 1.2;
                }
            </style>
        </head>

        <body>
            ${labels.join("")}
        </body>

        </html>
        `);

    setTimeout(() => {

        const barcodeContainers =
            printWindow.document.querySelectorAll(
                ".barcode-placeholder"
            );

        barcodeContainers.forEach(container => {

            const orderId =
                container.dataset.orderid;

            const svg =
                printWindow.document.createElementNS(
                    "http://www.w3.org/2000/svg",
                    "svg"
                );

            JsBarcode(svg, orderId, {
                format: "CODE128",
                width: 2,
                height: 40,
                margin: 0,
                displayValue: false,
                textMargin: 0
            });

            container.appendChild(svg);
        });

        setTimeout(() => {
            printWindow.focus();
            printWindow.print();
            printWindow.close();
        }, 300);

    }, 300);
};

const createLabelHtml = (order) => {

    const customerLines = wrapText(
        order.CustomerName,
        30
    );

    const itemLines = wrapText(
        `${order.ItemName} - ${order.Cargo}`,
        30
    );

    return `
        <div class="label">

            <div class="customer">
                ${customerLines.join("<br>")}
            </div>

            <div class="barcode">
                <div
                    class="barcode-placeholder"
                    data-orderid="${order.OrderID}"
                ></div>

                <div class="barcode-text">
                    ${order.OrderID}
                </div>
            </div>

            <div class="item">
                ${itemLines.join("<br>")}
            </div>

        </div>
    `;
};

const wrapText = (text = "", maxChars = 20) => {

    const words = text.split(" ");

    const lines = [];

    let currentLine = "";

    words.forEach(word => {

        if (
            (currentLine + " " + word)
                .trim()
                .length <= maxChars
        ) {
            currentLine +=
                (currentLine ? " " : "") + word;
        } else {
            lines.push(currentLine);
            currentLine = word;
        }
    });

    if (currentLine) {
        lines.push(currentLine);
    }

    return lines.slice(0, 2);
};











// ================= DOWNLOADABLE FILE VERSION =================

// import html2pdf from "html2pdf.js";
// import JsBarcode from "jsbarcode";

// export const downloadLabelsPdf = async (labels) => {
//     const container = document.createElement("div");

//     container.style.position = "fixed";
//     container.style.left = "-99999px";
//     container.style.top = "0";

//     container.innerHTML = `
//         <style>
//             .label{
//                 width:50mm;
//                 height:30mm;
//                 box-sizing:border-box;
//                 page-break-after:always;
//                 overflow:hidden;
//                 padding:2mm;
//                 display:flex;
//                 flex-direction:column;
//                 justify-content:space-between;
//                 font-family:Arial,sans-serif;
//             }

//             .customer{
//                 font-size:11px;
//                 font-weight:bold;
//                 line-height:1.2;
//             }

//             .barcode{
//                 text-align:center;
//             }

//             .barcode svg{
//                 width:100%;
//                 height:40px;
//             }

//             .barcode-text{
//                 font-size:8px;
//                 letter-spacing:1px;
//             }

//             .item{
//                 font-size:10px;
//                 line-height:1.2;
//             }
//         </style>

//         ${labels.join("")}
//     `;

//     document.body.appendChild(container);

//     container
//         .querySelectorAll(".barcode-placeholder")
//         .forEach((placeholder) => {

//             const svg = document.createElementNS(
//                 "http://www.w3.org/2000/svg",
//                 "svg"
//             );

//             JsBarcode(svg, placeholder.dataset.orderid, {
//                 format: "CODE128",
//                 width: 2,
//                 height: 40,
//                 margin: 0,
//                 displayValue: false,
//             });

//             placeholder.appendChild(svg);
//         });

//     await html2pdf()
//         .set({
//             filename: `Shipping_Labels_${Date.now()}.pdf`,
//             margin: 0,
//             image: {
//                 type: "jpeg",
//                 quality: 1,
//             },
//             html2canvas: {
//                 scale: 3,
//                 useCORS: true,
//             },
//             jsPDF: {
//                 unit: "mm",
//                 format: [50, 30],
//                 orientation: "landscape",
//             },
//             pagebreak: {
//                 mode: ["css", "legacy"],
//             },
//         })
//         .from(container)
//         .save();

//     container.remove();
// };

// export const printMarkedOrder = async (orders) => {

//     const labels = [];

//     orders
//         .filter(
//             order =>
//                 order.Remarks === "Marked" ||
//                 order.Remarks === "In_Transit"
//         )
//         .forEach(order => {

//             const qty = Number(order.ItemQty) || 1;

//             for (let i = 0; i < qty; i++) {
//                 labels.push(createLabelHtml(order));
//             }
//         });

//     if (!labels.length) {
//         Swal.fire({
//             icon: "info",
//             text: "No marked orders found.",
//         });
//         return;
//     }

//     await downloadLabelsPdf(labels);
// };